import { atom } from "jotai";
import useHttp from "../hooks/useHttp";

export const productSEOLoadingStatusAtom = atom("idle");
export const productSEOAtom = atom(null);

export const fetchProductSEOAtom = atom(null, async (get, set, seoCaliber) => {
  set(productSEOLoadingStatusAtom, "loading");

  const { getProductSEO } = useHttp();

  getProductSEO(seoCaliber)
    .then((response) => set(productSEOAtom, response.seo))
    .finally(() => set(productSEOLoadingStatusAtom, "idle"));
});
